import {method} from './core';

export function callSmsGetAll(options) {
  return method('sms', options);
}

export function callSmsSend(data) {
  return method('sms/send', data);
}



// WEBPACK FOOTER //
// ./src/helpers/api/sms.js